/* STILL. — theme runtime
   principles: no frameworks, no scroll hijacking, and no JS that
   transforms or fades text. images settle; glyphs never move. */
(function(){
'use strict';

/* ---------- header state ---------- */
var nav=document.getElementById('nav');
function syncNav(){
  if(!nav)return;
  var ghost=nav.getAttribute('data-ghost')==='true';
  if(ghost){
    nav.className=(window.scrollY<window.innerHeight*0.7)?'ghost':'ink scrolled';
  }else{
    nav.className=(window.scrollY<36)?'ink':'ink scrolled';
  }
}
window.addEventListener('scroll',function(){syncNav();buybarScroll();},{passive:true});
syncNav();

/* ---------- image reveals (images only, never text) ---------- */
var io=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}
  });
},{threshold:.12});
document.querySelectorAll('figure.ph.rv').forEach(function(f){io.observe(f);});

/* ---------- register hover preview ---------- */
var thumb=document.getElementById('idxThumb');
function hideThumb(){
  if(!thumb)return;
  thumb.classList.remove('on');
  var i=thumb.querySelector('img');
  if(i)i.removeAttribute('src');
}
if(thumb){
  var timg=thumb.querySelector('img');
  document.querySelectorAll('.idx-row').forEach(function(r){
    r.addEventListener('mouseenter',function(){
      timg.src=r.getAttribute('data-thumb');
      timg.style.objectFit=r.getAttribute('data-fit')||'cover';
      thumb.classList.add('on');
    });
    r.addEventListener('mouseleave',hideThumb);
    r.addEventListener('click',hideThumb);
    r.addEventListener('mousemove',function(e){
      thumb.style.left=(e.clientX+28)+'px';
      thumb.style.top=(e.clientY-130)+'px';
    });
  });
  window.addEventListener('pagehide',hideThumb);
}

/* ---------- bag drawer ---------- */
var scrim=document.getElementById('scrim');
function bagEl(){return document.getElementById('bag');}
function lockScroll(on){document.body.style.overflow=on?'hidden':'';}
function openBag(){var b=bagEl();if(!b)return;b.classList.add('on');if(scrim)scrim.classList.add('on');lockScroll(true);}
function closeBag(){var b=bagEl();if(!b)return;b.classList.remove('on');if(scrim)scrim.classList.remove('on');lockScroll(false);}

function refreshBag(html,open){
  if(typeof html==='string'){
    var wasOpen=bagEl()&&bagEl().classList.contains('on');
    var tmp=document.createElement('div');
    tmp.innerHTML=html;
    var fresh=tmp.querySelector('#bag')||tmp.firstElementChild;
    var cur=bagEl();
    if(fresh&&cur){cur.replaceWith(fresh);}
    if(wasOpen||open){var b=bagEl();if(b){b.classList.add('on');if(scrim)scrim.classList.add('on');lockScroll(true);}}
  }
  var countEl=document.getElementById('bagCount');
  var b2=bagEl();
  if(countEl&&b2&&b2.hasAttribute('data-count'))countEl.textContent='('+b2.getAttribute('data-count')+')';
}
function fetchBag(open){
  fetch(window.Shopify&&Shopify.routes?Shopify.routes.root+'?sections=still-cart-drawer':'/?sections=still-cart-drawer')
    .then(function(r){return r.json();})
    .then(function(j){refreshBag(j['still-cart-drawer'],open);})
    .catch(function(){});
}

document.addEventListener('click',function(e){
  if(e.target.closest('[data-drawer-open]')){e.preventDefault();openBag();return;}
  if(e.target.closest('[data-drawer-close]')){closeBag();return;}
  var q=e.target.closest('[data-line-q]');
  if(q){
    changeLine(q.getAttribute('data-line-key'),parseInt(q.getAttribute('data-line-q'),10));
    return;
  }
  var rm=e.target.closest('[data-line-remove]');
  if(rm){changeLine(rm.getAttribute('data-line-key'),0);return;}
  var qs=e.target.closest('[data-qty-minus],[data-qty-plus]');
  if(qs){
    var inp=qs.parentNode.querySelector('input[name="quantity"]');
    if(inp){
      var v=parseInt(inp.value,10)||1;
      inp.value=Math.max(1, v+(qs.hasAttribute('data-qty-plus')?1:-1));
    }
    return;
  }
});
if(scrim)scrim.addEventListener('click',closeBag);
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'){closeBag();hideThumb();}
});

function changeLine(key,qty){
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})
  }).then(function(){fetchBag(false);}).catch(function(){});
}

/* add-to-cart interception (native form fallback preserved) */
document.addEventListener('submit',function(e){
  var form=e.target.closest('form[data-still-product-form], form#StillProductForm');
  if(!form)return;
  e.preventDefault();
  var btn=form.querySelector('[type="submit"]');
  if(btn)btn.setAttribute('aria-busy','true');
  var fd=new FormData(form);
  fd.append('sections','still-cart-drawer');
  fetch('/cart/add.js',{method:'POST',body:fd})
    .then(function(r){return r.json();})
    .then(function(j){
      if(j.sections&&j.sections['still-cart-drawer']){refreshBag(j.sections['still-cart-drawer'],true);}
      else{fetchBag(true);}
    })
    .catch(function(){form.submit();})
    .finally(function(){if(btn)btn.removeAttribute('aria-busy');});
});

/* ---------- product: variants, price, hero, calm sold-out ---------- */
var pRoot=document.querySelector('[data-still-product]');
if(pRoot){
  var pdata=JSON.parse(pRoot.querySelector('[data-product-json]').textContent);
  var mediaAlts=[];
  try{mediaAlts=JSON.parse(pRoot.querySelector('[data-media-json]').textContent);}catch(err){}
  var form=pRoot.querySelector('form[data-still-product-form]')||pRoot.querySelector('#StillProductForm');
  var idInput=form?form.querySelector('input[name="id"]'):null;
  var priceEls=pRoot.querySelectorAll('[data-price]');
  var addBtns=pRoot.querySelectorAll('[data-add-label]');
  var microEl=pRoot.querySelector('[data-micro]');
  var hero=document.getElementById('pdpHero');
  var optName=function(i){return pdata.options[i];};

  function selectedOptions(){
    var vals=[];
    pdata.options.forEach(function(name,i){
      var chip=pRoot.querySelector('input[data-opt-index="'+i+'"]:checked');
      if(chip){vals.push(chip.value);return;}
      var sel=pRoot.querySelector('select[data-opt-index="'+i+'"]');
      if(sel){vals.push(sel.value);return;}
      vals.push(null);
    });
    return vals;
  }
  function findVariant(vals){
    return pdata.variants.find(function(v){
      return pdata.options.every(function(_,i){
        return !vals[i]||v[ 'option'+(i+1) ]===vals[i];
      });
    });
  }
  function money(cents){
    var n=cents/100;
    return '$'+(n%1===0?n.toFixed(0):n.toFixed(2));
  }
  function sized(u){
    if(!u||u.indexOf('width=')>-1)return u;
    return u+(u.indexOf('?')>-1?'&':'?')+'width=1600';
  }
  /* the hero <img> ships with srcset/sizes; a bare src swap is ignored
     while srcset is present, so clear them before pointing at the new photo */
  function swapHero(src,alt){
    if(!hero||!src)return;
    var next=sized(src);
    if(hero.currentSrc===next||hero.src===next)return;
    hero.style.opacity=0;
    setTimeout(function(){
      hero.onload=function(){hero.style.opacity=1;};
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.src=next;
      if(alt)hero.alt=alt;
    },280);
  }
  function heroForColor(color){
    if(!color||!hero||!mediaAlts.length)return;
    var lc=color.toLowerCase();
    var m=mediaAlts.find(function(x){return (x.alt||'').toLowerCase().indexOf(lc)>-1;});
    if(m&&m.src)swapHero(m.src,m.alt);
  }
  function sync(){
    var vals=selectedOptions();
    var v=findVariant(vals);
    if(!v)return;
    if(idInput)idInput.value=v.id;
    priceEls.forEach(function(el){el.textContent=money(v.price);});
    var away=!v.available;
    addBtns.forEach(function(b){
      b.disabled=away;
      b.classList.toggle('away',away);
      b.textContent=away?(pRoot.getAttribute('data-soldout-label')||'Temporarily away'):(pRoot.getAttribute('data-add-text')||'Add to the bag');
    });
    if(microEl){
      microEl.textContent=away?(pRoot.getAttribute('data-soldout-note')||''):(pRoot.getAttribute('data-micro-text')||'');
    }
    if(v.featured_image&&v.featured_image.src){
      swapHero(v.featured_image.src,v.featured_image.alt);
    }else{
      var colorIdx=pdata.options.findIndex(function(n){return /colou?r|colourway|finish/i.test(n);});
      if(colorIdx>-1)heroForColor(vals[colorIdx]);
    }
    if(history.replaceState){
      var url=new URL(window.location);
      url.searchParams.set('variant',v.id);
      history.replaceState({},'',url);
    }
    var val=pRoot.querySelector('[data-opt-value]');
    if(val){var first=selectedOptions()[0];if(first)val.textContent=first;}
  }
  pRoot.addEventListener('change',function(e){
    if(e.target.matches('[data-opt-index]'))sync();
  });
  sync();
}

/* ---------- sticky buy bar ---------- */
var buybar=document.getElementById('buybar');
function buybarScroll(){
  if(!buybar)return;
  var p=document.getElementById('purchase');
  if(!p)return;
  if(p.getBoundingClientRect().bottom<0){buybar.classList.add('on');}
  else{buybar.classList.remove('on');}
}
/* belt and braces: drive the bar from an IntersectionObserver too, so it
   works even where scroll events are throttled (iOS momentum scrolling) */
if(buybar&&'IntersectionObserver' in window){
  var pSec=document.getElementById('purchase');
  if(pSec){
    new IntersectionObserver(function(es){
      es.forEach(function(en){
        buybar.classList.toggle('on',!en.isIntersecting&&en.boundingClientRect.bottom<0);
      });
    }).observe(pSec);
  }
}
document.addEventListener('click',function(e){
  var proxy=e.target.closest('[data-buybar-add]');
  if(!proxy)return;
  /* primary path: native association via form="StillProductForm" — the
     browser submits the real form and the submit intercept takes over.
     only proxy manually when that association is missing. */
  if(proxy.form)return;
  e.preventDefault();
  var form=document.querySelector('form[data-still-product-form]')||document.getElementById('StillProductForm');
  if(!form)return;
  if(typeof form.requestSubmit==='function'){form.requestSubmit();}
  else if(form.dispatchEvent(new Event('submit',{bubbles:true,cancelable:true}))){form.submit();}
});

})();
